import {useReducer, useState} from 'react'
import pkg from 'lodash'
import {updateObject} from '../utils/Utility'

const {isArray} = pkg
const sensitiveFieldIds = [
  'password',
  'confirmPassword',
  'currentPassword',
  'credential',
  'confirmCredential',
  'currentCredential'
]

const getStateToLog = (fieldId, state) => {
  if (sensitiveFieldIds.includes(fieldId)) return '[REDACTED]'

  const stringifiedState = JSON.stringify(state)
  return stringifiedState ? stringifiedState.substring(0, Math.min(stringifiedState.length, 100)) : ''
}

/*
function used by useReducer
*/
const httpReducer = (prevState, currState) => {
  return {
    ...prevState,
    ...currState
  }
}

/*
Custom hook for managing User Manager page state for fields & errors
*/
const useFieldsStateHook = initialFieldsState => {
  const [fieldsState, setFieldsState] = useReducer(httpReducer, initialFieldsState)
  const [lastFieldChanged, setLastFieldChanged] = useState('')
  // const [normalizedOriginalUser,setnormalizedOriginalUser] = useState(null)

  const resetFieldsState = () => {
    setFieldsState(initialFieldsState)
  }

  const setFieldState = (fieldId, state) => {
    let fid = fieldId
    if(isArray(fieldId) && fieldId.length > 0)
      // eslint-disable-next-line prefer-destructuring
      fid = fieldId[0]
    let updatedState = state
    if(typeof state === 'function') {
      updatedState = state()
    }
    const stateToLog = getStateToLog(fid, updatedState)
    console.log(`LOG-DEBUG: setFieldState called for fieldId: ${fid}, state: ${stateToLog}`);
      const newState = updateObject(fieldsState, {
        [fid]: updateObject(fieldsState[fid], {...updatedState})
      })
      setLastFieldChanged(fieldsState[fid].id)
      setFieldsState(newState)
  }

  const setFieldStateWithPrev = (fieldId, prev, state) => {
    let fid = fieldId
    if(isArray(fieldId) && fieldId.length > 0)
      // eslint-disable-next-line prefer-destructuring
      fid = fieldId[0]
    let updatedState = state
    if(typeof state === 'function') {
      updatedState = state()
    }
    const stateToLog = getStateToLog(fid, updatedState)
    console.log(`LOG-DEBUG: setFieldStateWithPrev: called for fieldId: ${fid}, state: ${stateToLog}`);
      const newState = updateObject(prev, {
        [fid]: updateObject(prev[fid], {...updatedState})
      })
      setLastFieldChanged(fieldsState[fid].id)
      setFieldsState(newState) // use previous

  }

  return {
      fieldsState,
      lastFieldChanged,
      // normalizedOriginalUser,
      setFieldState,
      setFieldStateWithPrev,
      setFieldsState,
      setLastFieldChanged,
      resetFieldsState
    }
  }

  export default useFieldsStateHook
